import { SVGProps } from 'react'

export const MultiCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="480"
    height="437"
    viewBox="0 0 480 437"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_4778_14156"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="-43"
      width="480"
      height="480"
    >
      <rect
        width="480"
        height="480"
        transform="translate(0 -43)"
        fill="url(#paint0_radial_4778_14156)"
      />
    </mask>
    <g mask="url(#mask0_4778_14156)">
      <circle cx="240" cy="197" r="47.5" stroke="#EAECF0" />
      <circle cx="240" cy="197" r="79.5" stroke="#EAECF0" />
      <circle cx="240" cy="197" r="111.5" stroke="#EAECF0" />
      <circle cx="240" cy="197" r="143.5" stroke="#EAECF0" />
      <circle cx="240" cy="197" r="143.5" stroke="#EAECF0" />
      <circle cx="240" cy="197" r="175.5" stroke="#EAECF0" />
      <circle cx="240" cy="197" r="207.5" stroke="#EAECF0" />
      <circle cx="240" cy="197" r="239.5" stroke="#EAECF0" />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_4778_14156"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(240 240) rotate(90) scale(240 240)"
      >
        <stop />
        <stop offset="1" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
)
